import type { Translations } from '../models';
import type { GetUrlOptions } from './getUrl';
import { getUrl } from './getUrl';

export function fetchTranslations(
  url: string,
  options: GetUrlOptions,
  onSuccess: (result: Translations) => void,
  onError: (error: Error) => void,
) {
  getUrl<Translations>(url, options, onSuccess, onError);
}
